/** @jsx isolateComponent */

import { Fragment } from 'react';

import { AsyncIndicator } from '@zapier/common-components';
import { isolateComponent } from '@zapier/common-utils';
import { Link } from '@zapier/design-system';
import { useTrackingContext } from '@zapier/toolbox-tracking';

import { EVENT_ANNUAL_BILLING_NUDGE } from '@zapier/design-system-revenue/src/constants';
import { buildPlanChangeUrl } from '@zapier/design-system-revenue/src/utils';

import { Props as UseDataProps, useData as _useData } from './useData';

type Props = {
  /** For dependency injection testing only */
  useData?: () => ReturnType<typeof _useData>;
};

const AnnualBillingBanner = ({ useData = _useData }: Props) => {
  const {
    currentPlanName,
    error,
    isLoading,
    yearlyDiscountPercentage,
  } = useData();

  const { trackEvent } = useTrackingContext();

  if (isLoading) {
    return <AsyncIndicator />;
  }

  if (!currentPlanName || !!error) {
    return <Fragment>{error}</Fragment>;
  }

  const percentage = yearlyDiscountPercentage
    ? `${yearlyDiscountPercentage}%`
    : '';

  const url = buildPlanChangeUrl('change', currentPlanName);

  return (
    <Fragment>
      <Link href={url} onClick={() => trackEvent(EVENT_ANNUAL_BILLING_NUDGE)}>
        Save {percentage}
      </Link>{' '}
      by switching to an annual subscription. <Link href={url}>Switch Now</Link>
    </Fragment>
  );
};

AnnualBillingBanner.shouldRender = function shouldRender(
  props: UseDataProps = {}
) {
  return _useData.call(this, props)?.shouldRender;
};

export { AnnualBillingBanner };
